// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import vSelect from 'vue-select';
import VueMeta from 'vue-meta';
import VueGtag from 'vue-gtag';

// Import only the Bootstrap Vue components that are actually used
import {
  // Layout
  BContainer,
  BCol,
  BFormRow,
  // Navigation
  BNavbar,
  BNavbarBrand,
  BNavbarToggle,
  BNavbarNav,
  BNav,
  BNavItem,
  BCollapse,
  // Buttons
  BButton,
  BButtonGroup,
  // Cards
  BCard,
  // Forms
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
  BFormRadioGroup,
  // Display
  BSpinner,
  BAlert,
  BBadge,
  BAvatar,
  BProgress,
  BLink,
  // Carousel
  BCarousel,
  BCarouselSlide,
  // Modal
  BModal,
  // Directives
  VBToggle,
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import Loader from '@/components/widgets/Loader';
import VueMasonry from 'vue-masonry-css';
import 'vue-select/dist/vue-select.css';
import LoadScript from 'vue-plugin-load-script';
import VueAnalytics from 'vue-analytics';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faExternalLinkAlt, faUser, faChevronLeft, faCheck, faCreditCard, faCaretDown, faFileInvoiceDollar, faEllipsisV, faChevronRight, faPlus, faHome, faTruck, faTshirt, faKey, faFileCsv, faShoppingCart, faThumbsUp, faThumbsDown, faUpload, faFile, faTimes, faQuestion, faDollarSign, faMobile, faEnvelope, faThumbtack, faBars, faSignOutAlt, faSyncAlt, faHeart, faChevronUp, faChevronDown, faEllipsisH, faTh, faThLarge, faFingerprint, faRedo, faCaretLeft, faCircle, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faCcMastercard, faCcVisa, faFacebook, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('v-select', vSelect);

library.add(faCaretLeft, faFingerprint, faExternalLinkAlt, faTh, faThLarge, faCcVisa, faCcMastercard, faHeart, faSyncAlt, faBars, faSignOutAlt, faMobile, faEnvelope, faThumbtack, faDollarSign, faUser, faInstagram, faTwitter, faFacebook, faChevronLeft, faChevronUp, faChevronDown, faCheck, faCreditCard, faCaretDown, faFileInvoiceDollar, faEllipsisV, faEllipsisH, faChevronRight, faPlus, faHome, faTruck, faTshirt, faKey, faFileCsv, faShoppingCart, faThumbsUp, faThumbsDown, faArrowRight, faUpload, faCheck, faFile, faTimes, faQuestion, faRedo, faCircle);
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
Vue.config.productionTip = false;

// Register only the Bootstrap Vue components we actually use
Vue.component('BContainer', BContainer);
Vue.component('BCol', BCol);
Vue.component('BFormRow', BFormRow);
Vue.component('BNavbar', BNavbar);
Vue.component('BNavbarBrand', BNavbarBrand);
Vue.component('BNavbarToggle', BNavbarToggle);
Vue.component('BNavbarNav', BNavbarNav);
Vue.component('BNav', BNav);
Vue.component('BNavItem', BNavItem);
Vue.component('BCollapse', BCollapse);
Vue.component('BButton', BButton);
Vue.component('BButtonGroup', BButtonGroup);
Vue.component('BCard', BCard);
Vue.component('BForm', BForm);
Vue.component('BFormGroup', BFormGroup);
Vue.component('BFormInput', BFormInput);
Vue.component('BFormCheckbox', BFormCheckbox);
Vue.component('BFormTextarea', BFormTextarea);
Vue.component('BFormRadioGroup', BFormRadioGroup);
Vue.component('BSpinner', BSpinner);
Vue.component('BAlert', BAlert);
Vue.component('BBadge', BBadge);
Vue.component('BAvatar', BAvatar);
Vue.component('BProgress', BProgress);
Vue.component('BLink', BLink);
Vue.component('BCarousel', BCarousel);
Vue.component('BCarouselSlide', BCarouselSlide);
Vue.component('BModal', BModal);

// Register the v-b-toggle directive
Vue.directive('b-toggle', VBToggle);
Vue.use(Loader);
Vue.use(VueMasonry);
Vue.use(LoadScript);
Vue.use(VueMeta);

Vue.use(VueAnalytics, {
  id: 'UA-221726265-1',
  router,
});

Vue.use(VueGtag, {
  config: { id: 'GTM-NHJGJ49P' },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js